export default __webpack_public_path__ + "static/look-22c9d5a819586299c8ad2167d259da0d.png";